import JiraIntegrationTable from './jira_integration_table';
export default JiraIntegrationTable;
